// Regra da etiqueta lida por QR Code: UF(2) + TIPO(1) + CARTELA(10) + SEQ(3) = 16 caracteres.
// Mesma tabela de casos do APP (lib/features/laudo/domain/etiqueta_qrcode.dart).
export type TipoVeiculoLaudo = "auto_leve" | "moto" | "caminhao" | "onibus";
export type ErroEtiqueta = "formato_invalido" | "nao_rastreavel" | "etiqueta_avulsa" | "tipo_divergente";
export type ResultadoEtiqueta =
  | { ok: true; cartela: string }
  | { ok: false; erro: ErroEtiqueta; mensagem: string };

const UFS = new Set(
  "AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO".split(" "),
);

const TIPO_POR_DIGITO: Record<string, TipoVeiculoLaudo> = {
  "1": "auto_leve", "2": "moto", "3": "caminhao", "4": "onibus",
};

const ROTULO_TIPO: Record<TipoVeiculoLaudo, string> = {
  auto_leve: "Auto/Leve", moto: "Moto", caminhao: "Caminhão", onibus: "Ônibus",
};

export const MSG_ETIQUETA_INVALIDA = "QR Code não contém uma etiqueta válida.";
export const MSG_ETIQUETA_NAO_RASTREAVEL = "Etiqueta Não Rastreável não permitida no sistema!";
export const MSG_ETIQUETA_AVULSA = "Etiqueta Avulsa não é a cartela do veículo. Leia uma etiqueta da cartela.";

const falha = (erro: ErroEtiqueta, mensagem: string): ResultadoEtiqueta => ({ ok: false, erro, mensagem });

export function lerCartelaDaEtiqueta(textoLido: string, tipoLaudo: TipoVeiculoLaudo): ResultadoEtiqueta {
  const bruto = String(textoLido ?? "");
  // URL: só o trecho após a última "/" (barras finais não contam).
  const trecho = bruto.includes("/") ? bruto.trim().replace(/\/+$/, "").split("/").pop()! : bruto;
  const etiqueta = trecho.replace(/\s+/g, "").toUpperCase();

  if (!/^[A-Z]{2}\d{14}$/.test(etiqueta) || !UFS.has(etiqueta.slice(0, 2))) {
    return falha("formato_invalido", MSG_ETIQUETA_INVALIDA);
  }

  const digito = etiqueta[2];
  if (digito === "0") return falha("formato_invalido", MSG_ETIQUETA_INVALIDA);
  if (digito >= "6") return falha("nao_rastreavel", MSG_ETIQUETA_NAO_RASTREAVEL);
  // avulsa (5) é uma etiqueta à parte da cartela original: nunca preenche o campo da cartela
  if (digito === "5") return falha("etiqueta_avulsa", MSG_ETIQUETA_AVULSA);

  const tipoEtiqueta = TIPO_POR_DIGITO[digito];
  if (tipoEtiqueta !== tipoLaudo) {
    return falha(
      "tipo_divergente",
      `Etiqueta de ${ROTULO_TIPO[tipoEtiqueta]}, mas o laudo é de ${ROTULO_TIPO[tipoLaudo]}.`,
    );
  }
  return { ok: true, cartela: etiqueta.slice(3, 13) };
}
